
import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Edit, Save, X } from 'lucide-react';
import { SecurityHeader } from './security/SecurityHeader';
import { AuthenticationTab } from './security/AuthenticationTab';
import { PermissionsTab } from './security/PermissionsTab';
import { ApiKeysTab } from './security/ApiKeysTab';
import { AuditLogsTab } from './security/AuditLogsTab';

interface SecurityAccessSettingsProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const SecurityAccessSettings: React.FC<SecurityAccessSettingsProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState('authentication');

  return (
    <Card>
      <SecurityHeader 
        editing={editing} 
        onEditToggle={onEditToggle} 
        onSave={onSave} 
      />
      <CardContent className="space-y-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid grid-cols-4 sm:w-auto w-full">
            <TabsTrigger value="authentication">Authentication</TabsTrigger>
            <TabsTrigger value="permissions">Permissions</TabsTrigger>
            <TabsTrigger value="apikeys">API Keys</TabsTrigger>
            <TabsTrigger value="audit">Audit Logs</TabsTrigger>
          </TabsList>
          
          <TabsContent value="authentication">
            <AuthenticationTab editing={editing} />
          </TabsContent>
          
          <TabsContent value="permissions">
            <PermissionsTab />
          </TabsContent>
          
          <TabsContent value="apikeys">
            <ApiKeysTab editing={editing} />
          </TabsContent>
          
          <TabsContent value="audit">
            <AuditLogsTab />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default SecurityAccessSettings;
